import React, { useState, useCallback } from 'react';
import axios from 'axios';
import { Atom } from "react-loading-indicators";
import { useDropzone } from 'react-dropzone';
//import './App.css';

function BulkEmails() {

  const [fileData, setFileData] = useState(new FormData());
  const [isLoading, setIsLoading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false); // Loading state for processing
  const [selectedPlatform, setSelectedPlatform] = useState('Hunter');

    // Styles
  const styles = {
    pageContainer: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '10vh', // Start 10% down the page
    },
    appContainer: () => ({
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      maxWidth: '100%',
      padding: '10px',
    }),
    formContainer: () => ({
      width: '100%',
      maxWidth: '400px',
      transition: 'all 0.5s ease',
      padding: '20px',
    }),
    form: {
      display: 'flex',
      flexDirection: 'column',
    },
    headerText: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '14px',
      marginTop: '10px',
      marginBottom: '20px',
      borderBottom: '1px solid black',
    },
    input: {
      margin: '5px 0',
      padding: '7px',
      borderRadius: '4px',
      border: '1px solid #cccccc',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
    },
    button: {
      margin: '10px 0',
      padding: '10px',
      backgroundColor: '#6487dc',
      color: 'white',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '4px',
    },
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData(); // Ensure FormData is initialized

    for (let [key, value] of fileData.entries()) {
      formData.append(key, value); // Append files to formData
    }

    formData.append('platform', selectedPlatform);

    axios.post('/api/fetch_bulk_emails', formData, {
      responseType: 'blob',
      headers: {'Content-Type': 'multipart/form-data'},
    })
    .then((response) => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'Buyer_Emails.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    setIsLoading(false);
  })
  .catch((error) => {
    setIsLoading(false);
    console.error('Error submitting form:', error);
  });
  };

  const onDrop = useCallback((acceptedFiles) => {

    const sortedFiles = acceptedFiles.sort((a, b) => a.name.localeCompare(b.name));

    const newFormData = new FormData();

    sortedFiles.forEach(file => {
      newFormData.append('files', file); // Append valid files to FormData
    });
    
  setFileData(newFormData);
  setIsUploaded(true);
  }, []); // Add headers as dependency

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ 
    onDrop, 
    accept: {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"], // For .xlsx files
      "application/vnd.ms-excel": [".xls"], // For .xls files
    },
    multiple: false // Enable multiple file selection
  });

  const FileList = () => (
    <div style={fileListStyle}>
      <ul>
      {Array.from(fileData.entries()).map(([key, value], index) => (
      <li key={index} style={fileListItemStyle}>
        {value.name}
      </li>
      ))}
      </ul>
    </div>
  );

  const ClearButton = () => (
    <button 
      onClick={() => {
        setFileData(new FormData());
        setIsUploaded(false);
      }}
      style={clearButtonStyle}
    >
      Clear File
    </button>
  );

  const fileListItemStyle = {
    marginBottom: '5px',
  };

  const fileListStyle = {
    marginTop: '10px',
    marginBottom: '20px',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    '& ul': {
      margin: '5px 0',
      paddingLeft: '20px',
    },
    '& li': {
      marginBottom: '3px',
    }
  };

  const fileManagementStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '20px',
  };

  const clearButtonStyle = {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    cursor: 'pointer',
    fontSize: '0.9em',
    marginTop: '10px',
    '&:hover': {
      backgroundColor: '#c82333',
    },
  };

  const dropzoneStyles = {
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    marginBottom: '20px',
    backgroundColor: '#FFFFFF',
    opacity: 0.9,
  };

  return (
    <div style={styles.appContainer()}>
        <div style={styles.formContainer()}>
        <form onSubmit={handleSubmit} style={styles.form}>
            <h3 style={styles.headerText}>Buyer Email List</h3>
            <div {...getRootProps()} style={dropzoneStyles}>
          <input {...getInputProps()} />
          {isDragActive ? 
            <p>Drop the Excel files here ...</p> : 
            <p>Drag and drop the list or click to upload</p>
          }
          </div>

          {isUploaded && (
          <div style={fileManagementStyle}>
            <FileList />
            <ClearButton />
          </div>
          )}

          <div style={{ margin: '16px 0', display: 'flex', gap: '20px', justifyContent: 'center' }}>
            <label>
              <input
                type="radio"
                name="platform"
                value="Hunter"
                checked={selectedPlatform === 'Hunter'}
                onChange={() => setSelectedPlatform('Hunter')}
              />
              Hunter
            </label>
            <label>
              <input
                type="radio"
                name="platform"
                value="CrewAI"
                checked={selectedPlatform === 'CrewAI'}
                onChange={() => setSelectedPlatform('CrewAI')}
              />
              CrewAI
            </label>
          </div>

          {isLoading && <div align="center"><Atom color="#32cd32" size="medium" text="Processing..." /></div>}
          <button type="submit" disabled={isLoading} style={styles.button}>Submit</button>
          <p><strong>Instructions:</strong></p>
          <ul style={{ paddingLeft: 0, listStylePosition: "inside", margin: 0, listStyleType: "decimal" }}>
            <li style={{ marginBottom: '10px' }}>
              The file should be in Excel format.
            </li>
            <li style={{ marginBottom: '10px' }}>
              Column header is required.
            </li>
            <li>
              The first column should contain:
              <ul style={{ margin: '6px 0 10px 0', listStyleType: 'disc', paddingLeft: '1em' }}>
                <li style={{ marginBottom: '5px' }}>
                  Website URLs if you're using <strong>Hunter</strong>.
                </li>
                <li>
                  Company names if you're using <strong>CrewAI</strong>.
                </li>
              </ul>
            </li>
          </ul>

        </form>
        </div>

    </div>
  );
}

export default BulkEmails;
